import { Button, Card, CardContent, Grid, CardHeader, Typography, Box, IconButton } from "@mui/material";
import { useState } from "react";
import { apiConstants, getGeneric, postGeneric } from '../../common/constants'
import * as React from 'react'
import PageTitle from "../../components/PageTitle";
import { useSnackbar } from "notistack";
import Loader from "../../components/Loader";
import { useFieldArray, useForm } from "react-hook-form";
import { FormProvider, RHFRadioGroup, RHFSelectField, RHFTextField } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import RHFMultipleSelectField from "../../common/hook-form/RHFMultipleSelectField";
import { useGetAllActiveMerchantsIdAndNameCachedQuery, useGetAllCourierPartnersCachedQuery } from "../../redux/commonApiCalls";
import _ from "lodash";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";



function AutoApproveReturn() {
    const [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const [reload, setReload] = useState(0)
    const [setid, setSetid] = useState(null)
    const andfilter = [{ "field": "is_deleted", "operator": "eq", "value": '0' }];
    const filter = {
        "andfilter": andfilter,
        "offset": 0,
        "limit": 1000,
        "skipCount": true,
        "includes": "id,name,cpAccountCode,prozoId,supportedShipmentType,isBlended,type"
    }
    const { data } = useGetAllCourierPartnersCachedQuery(filter);


    const validationSchema = Yup.object().shape({
        merchant: Yup.string().required('Merchant is required'),
        // rvpReasons: Yup.string().required('RVP Reasons are required'),
        // skuIDs: Yup.string().required('SKU IDs are required'),
        // autoApprovalReasons: Yup.array().min(1, 'At least one auto approval reason is required'),
        // isSkipRule: Yup.boolean(),
        // skipRuleProzoId: Yup.string().when('isSkipRule', (isSkipRule, schema) => {
        //     return isSkipRule
        //         ? schema.required('Skip Rule Prozo ID is required when skip rule is enabled')
        //         : schema.notRequired();
        // }),
    });

    const methods = useForm({
        defaultValues: {
            merchantId: '',
            merchant: '',
            list: [
                {
                    rvpReasons: ''
                },
            ],
            skuIDs: '',
            autoApprovalReasons: [],
            optionalReturnImages: [],
            isSkipRule: false,
            courier: ''
        },
        resolver: yupResolver(validationSchema)
    });

    const {
        handleSubmit,
        reset,
        watch,
        setValue,
        control
    } = methods;
    const { fields, append, remove } = useFieldArray({
        control,
        name: "list"
    });


    const onSubmit = (data) => {
        setLoading(true)
        const merchant = activeMerchant.find(merchant => merchant.id === data.merchant)
        const rvpReasonsArray = data.list?.map(reason => reason.rvpReasons).filter(reason => reason);
        const skuIDsArray = data.skuIDs.split(',').map(sku => sku.trim()).filter(sku => sku);

        const payload = {
            "merchantId": merchant.merchantId,
            "merchantOid": data.merchant,
            "rvpReasons": rvpReasonsArray,
            "skuIDs": skuIDsArray || ['TEST001'],
            "autoApprovalReasons": data.autoApprovalReasons,
            "optionalReturnImages": data.optionalReturnImages,
            "isSkipRule": data.isSkipRule,
        }
        if (data.isSkipRule) {
            payload.skipRuleProzoId = data.courier
        }
        if (setid) {
            payload.id = setid
        }
        const url = setid ? apiConstants.RETURN_CONFIG_UPDATE : apiConstants.RETURN_CONFIG
        postGeneric(url, payload, {
        }).then((res) => {
            enqueueSnackbar("Success", { variant: 'success' });
            setReload(reload + 1)
            setLoading(false)
        }).catch((err) => {
            setLoading(false)
            enqueueSnackbar("Some error occurred", { variant: 'error' });
            console.log(err);
        })
    };

    const merchantValue = watch('merchant')
    const isSkipRuleValue = watch('isSkipRule')
    const rvpReasonsValue = watch('list')

    const merchantFilter = () => {
        if (merchantValue) {
            setLoading(true)
            getGeneric(`${apiConstants.RETURN_CONFIG_GET}?merchantOid=${merchantValue}`).then((res) => {
                if (res.data) {
                    const config = res.data;
                    setValue('merchant', config.merchantOid || '');
                    setValue(
                        'list',
                        config.rvpReasons.map(reason => ({ rvpReasons: reason }))
                    );
                    setValue('skuIDs', config.skuIDs ? config.skuIDs.join(', ') : '');
                    setValue('autoApprovalReasons', config.autoApprovalReasons || []);
                    setValue('optionalReturnImages', config.optionalReturnImages || []);
                    setValue('isSkipRule', config.isSkipRule ? true : false);
                    setValue('courier', config.skipRuleProzoId || '');
                    setSetid(config.id)
                } else {
                    setSetid(null)
                    setValue('list', [{ rvpReasons: '' }])
                    setValue('skuIDs', '')
                    setValue('autoApprovalReasons', [])
                    setValue('optionalReturnImages', [])
                    setValue('isSkipRule', false)
                    setValue('courier', '')
                }
                setLoading(false)
            }).catch((err) => {
                setLoading(false)
                console.log(err);
            })
        }
    }

    React.useEffect(() => {
        if (merchantValue) {
            merchantFilter()
        }
    }, [merchantValue, reload])

    const { data: merchants = [] } = useGetAllActiveMerchantsIdAndNameCachedQuery()
    const activeMerchant = merchants.filter((val) => val.is_deleted === "0")

    return (
        <>
            <PageTitle>Return Rules & Auto-Approval Configuration</PageTitle>
            {loading && <Loader />}
            <Card sx={{ mb: 2 }}>
                <CardHeader
                    title='Return Rules & Auto-Approval Configuration'
                    subheader='Set up return reasons, SKU restrictions, and automatic approval rules for merchant returns'
                />
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12}>
                                <RHFSelectField
                                    width="100%"
                                    name="merchant"
                                    label="Select Merchant"
                                    options={_.orderBy(activeMerchant, "name").map((val) => ({
                                        value: val.id,
                                        label: val.name
                                    }))}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                    Return Reasons
                                </Typography>

                                <Box
                                    sx={{
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 2,
                                        p: 2,
                                        backgroundColor: '#fafafa',
                                        minHeight: 100,
                                        maxHeight: 300,
                                        overflowY: 'auto',
                                    }}
                                >
                                    {fields.map((field, index) => (
                                        <Grid container spacing={2} alignItems="center" key={field.id} sx={{ mb: 1 }}>
                                            <Grid item xs={10} sx={{ mt: 1 }}>
                                                <RHFTextField
                                                    name={`list.${index}.rvpReasons`}
                                                    label={`Reason ${index + 1}`}
                                                    fullWidth
                                                    placeholder="Enter reason"
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <IconButton
                                                    onClick={() => remove(index)}
                                                    color="error"
                                                    disabled={fields.length === 1}
                                                >
                                                    <RemoveCircleOutlineIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Box>

                                <Box sx={{ mt: 1 }}>
                                    <Button
                                        onClick={() => append({ rvpReasons: '' })}
                                        variant="contained"
                                        color="warning"
                                        startIcon={<AddIcon />}
                                        size="small"
                                    >
                                        Add Reason
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFMultipleSelectField
                                    width="100%"
                                    name="optionalReturnImages"
                                    label="Optional Return Images"
                                    options={rvpReasonsValue
                                        ?.filter(reason => reason.rvpReasons && reason.rvpReasons.trim() !== '')
                                        ?.map(reason => ({
                                            value: reason.rvpReasons,
                                            label: reason.rvpReasons
                                        })) || []}
                                    helperText="Select reasons that should be optional return images"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFMultipleSelectField
                                    width="100%"
                                    name="autoApprovalReasons"
                                    label="Auto Approval Reasons"
                                    options={rvpReasonsValue
                                        ?.filter(reason => reason.rvpReasons && reason.rvpReasons.trim() !== '')
                                        ?.map(reason => ({
                                            value: reason.rvpReasons,
                                            label: reason.rvpReasons
                                        })) || []}
                                    helperText="Select reasons that should be auto-approved"
                                />
                            </Grid>
                            <Grid item xs={6} sx={{ mt: 2 }}>
                                <RHFTextField
                                    name="skuIDs"
                                    label="Non-Returnable SKU IDs"
                                    placeholder="Enter comma-separated SKU IDs (e.g., SKU001, SKU002)"
                                    helperText="Enter multiple SKU IDs separated by commas"
                                    multiline
                                />
                            </Grid>
                            <Grid item xs={6} sx={{ mt: 1}}>
                                <RHFRadioGroup label="Courier Selection" name="isSkipRule" options={[
                                    { label: 'Auto', value: false },
                                    { label: 'Let Me Choose', value: true },
                                ]} />
                            </Grid>
                            {(isSkipRuleValue === 'true' || isSkipRuleValue === true) && (
                                <Grid item xs={6} sx={{ mt: 1 }}>
                                    <RHFSelectField
                                        width="100%"
                                        name="courier"
                                        label="Select Courier"
                                        options={_.orderBy(data, 'name').map(val => ({
                                            value: val.prozoId,
                                            label: val.prozoId,
                                        }))}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    sx={{ mt: 1 }}
                                    size="small"
                                    type="submit"
                                >
                                    Submit
                                </LoadingButton>
                                <Button
                                    sx={{ ml: 1, mt: 1 }}
                                    variant="contained"
                                    color="error"
                                    size="small"
                                    onClick={() => {
                                        reset();
                                    }}
                                >
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
        </>
    );
}

export default AutoApproveReturn;